module.exports = __webpack_public_path__ + "iconoLogistica512.png";